import state from './requestForProposal.state'

export default {
  state
}
